import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectToService {

  openNewTab() {
    const newTabWindow = window.open('', 'Map');
    return newTabWindow;
  }

  updateTabLocation(tabLocation, tab) {
    if (!tabLocation) {
      tab.close();
    }
    tab.location.href = tabLocation;
  }

  onPromise(): Promise<string> {
    return Promise.resolve('true');
  }
}
